export enum ErrorEnum {
  BAD_REQUEST = 400,
  NOT_AUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_INTERNAL_ERROR = 500,
  /** The React tree crashed (rendered by the global error boundary), not an API error. */
  APP_CRASH = 'app-crash',
}
